export * from '../src/lib/badge.module';
export * from '../src/lib/badge/badges-control';
